import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
//
// 語系
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// style
// components
import TemplateAuth from "../components/TemplateAuth";
import CustomSignUpUI from "./components/signup/CustomSignUpUI";
import useGotoWorkingArea from "../components/hook/useGotoWorkingArea";
// utils

//
const SignupPage = () => {
  // 語系
  // props
  // store
  // local state
  // hooks: 若使用者已登入,則導向其他頁面
  const isLoggedIn = useGotoWorkingArea();

  return (
    <TemplateAuth>
      <Grid container justifyContent="center">
        <Grid item>
          <Box my={10}>
            <CustomSignUpUI />
          </Box>
        </Grid>
      </Grid>
    </TemplateAuth>
  );
};

SignupPage.propTypes = {};

SignupPage.defaultProps = {};

export default SignupPage;
